import {CodeName} from './code-name';
import {GUID} from "../../shared/models/GUID-interface";

export class SelectedFilter {
    constructor(
        public readonly name: string, public readonly type: number, public readonly position: number
    ) {
        this.selectedQuantity = 0;
        this.allItemsQuantity = 0;
        this.data = [];
        this.dataString = '';
    }

    public selectedQuantity: number;
    public allItemsQuantity: number;
    public data: CodeName[];
    public dataString: string;
}

export class SelectedFilterGUID implements GUID{
    constructor(public readonly GUID: string, public readonly selectedFilters: SelectedFilter[]) {
    }
}



// WEBPACK FOOTER //
// ./src/app/stocks/models/selected-filter.ts